import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { GpaCalc } from "../components/GpaCalc";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.gpa_tool_name()}
        toolPath="/gpa-calculator"
      />
      <SciHeader title={m.gpa_h1()} intro={m.gpa_intro()} />
      <GpaCalc />
      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.gpa_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.gpa_ex1(), m.gpa_ex2(), m.gpa_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.gpa_faq_q1(), a: m.gpa_faq_a1() },
          { q: m.gpa_faq_q2(), a: m.gpa_faq_a2() },
          { q: m.gpa_faq_q3(), a: m.gpa_faq_a3() },
          { q: m.gpa_faq_q4(), a: m.gpa_faq_a4() },
        ]}
      />
      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
